import { AcroNode } from "./types";
import { escapeHtml } from "./escapeHtml";

export function renderCheckbox(node: AcroNode): string {
  const id = escapeHtml(String(node.id ?? ""));
  const fieldId = node.field_id ? escapeHtml(String(node.field_id)) : "";
  const title = node.title ? escapeHtml(String(node.title)) : "";
  const fieldIdAttr = fieldId ? ` data-field-id="${fieldId}"` : "";
  const input = `<input type="checkbox" data-id="${id}"${fieldIdAttr} class="form-checkbox" ${node.checked ? "checked" : ""} />`;
  const label = `<span class="text-sm">${title}</span>`;
  return `<label class="flex items-center gap-2">${input}${label}</label>`;
}
